module.exports = __webpack_public_path__ + "static/img/bg-es.7e6e6e09.png";